import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import settings from 'app/core/settings';
import { deleteImpersonificationUser } from 'app/pages/Admin/Impersonification/impersonificationUser';
import { openModal, confirmDelete } from 'app/components/Modal';
import { ReportingModal } from 'app/containers/Reporting/ReportingModal.jsx';
import { permission } from 'app/containers/Permissions/Permission.jsx';
import { NavMenuItem } from 'app/main/Authenticated/Header/NavMenuItem';
import { userReducerSelector } from 'app/store/selectors/user';
import classes from 'app/main/Authenticated/Header/Header.module.scss';
import vars from 'app/styles/vars.js';
const User = () => {
    var _a;
    const history = useHistory();
    const user = useSelector(userReducerSelector);
    if (!(user === null || user === void 0 ? void 0 : user.assetInst))
        return null;
    const { assetInst: { name, thumbnailInst }, } = user;
    function onLogout() {
        deleteImpersonificationUser();
        history.push('/authentication/logout');
    }
    function renderUserLogo() {
        let logo = _jsx("div", { style: { textTransform: 'capitalize' }, children: name });
        if (thumbnailInst && thumbnailInst.url) {
            logo = (_jsx("div", { className: "flex column center alignCenter", children: _jsx("div", { style: {
                        width: 30,
                        height: 30,
                        borderRadius: '50%',
                        border: '2px solid grey',
                        background: `center / cover no-repeat url('${thumbnailInst.url}')`,
                    } }) }));
        }
        return logo;
    }
    function renderReportMenu() {
        return {
            label: 'Report',
            icon: 'fas-bug',
            onClick: () => {
                openModal(_jsx(ReportingModal, { user: user }));
            },
        };
    }
    const navItems = [
        {
            label: 'Reset browser cache',
            onClick: () => confirmDelete({
                title: 'Reseting the browser cache',
                render: 'Are you sure you want to reset the entire browser cache ?',
                onValidate: () => {
                    localStorage.clear();
                    document.location.reload();
                    return Promise.resolve();
                },
                validateLabel: 'Reset',
            }),
            icon: 'fas-trash-alt',
        },
        {
            label: 'Logout',
            onClick: onLogout,
            icon: 'fas-sign-out-alt',
            style: { backgroundColor: vars.colors.red, color: '#ffffff' },
        },
    ];
    if (permission(['Overmind___Reporting'])) {
        navItems.unshift(renderReportMenu());
    }
    if ((_a = settings.git) === null || _a === void 0 ? void 0 : _a.CI_COMMIT_TAG) {
        navItems.push({
            label: `version ${settings.git.CI_COMMIT_TAG}`,
            icon: 'fas-sign-out-alt',
            disabled: true,
        });
    }
    return (_jsx("div", { className: classes.userAccount, children: _jsx(NavMenuItem, { items: navItems, children: renderUserLogo() }) }));
};
export default User;
